import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { FaArrowUp } from 'react-icons/fa';
import '../css/HomeButton.css';

const HomeButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const buttonRef = useRef(null);
  const scrollThreshold = 100; // Ngưỡng cuộn để hiển thị nút (px)

  // Sử dụng useCallback để tối ưu hiệu suất
  const handleScroll = useCallback(() => {
    // Lấy vị trí của navbar
    const navbar = document.querySelector('.s-header');
    const scrollY = window.scrollY || window.pageYOffset;
    
    // Hiển thị nút khi đã cuộn quá ngưỡng
    if (scrollY > scrollThreshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, []);

  // Sử dụng Intersection Observer API để theo dõi navbar
  useEffect(() => {
    const navbar = document.querySelector('.s-header');
    if (!navbar) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Nếu navbar không còn hiển thị trong viewport
        if (!entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0 } // Kích hoạt ngay khi navbar bắt đầu biến mất
    );

    observer.observe(navbar);

    // Đồng thời vẫn giữ sự kiện scroll để xử lý trường hợp cuộn nhanh
    let scrollTimeout;
    const throttledScroll = () => {
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(() => {
          handleScroll();
          scrollTimeout = null;
        }, 100); // Throttle 100ms
      }
    };

    window.addEventListener('scroll', throttledScroll);
    
    // Gọi một lần để kiểm tra trạng thái ban đầu
    handleScroll();
    
    // Hủy đăng ký sự kiện và observer khi component unmount
    return () => {
      window.removeEventListener('scroll', throttledScroll);
      clearTimeout(scrollTimeout);
      observer.disconnect();
    };
  }, [handleScroll, location.pathname]); // Thêm location.pathname để đảm bảo chạy lại khi chuyển trang

  // Xử lý sự kiện click - chỉ cuộn lên đầu trang
  const handleClick = (e) => {
    e.preventDefault();
    
    // Cuộn lên đầu trang với hiệu ứng mượt
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Xử lý phím tắt (Alt+T) để kích hoạt nút cuộn lên đầu trang
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Alt + T (T cho "Top")
      if (e.altKey && e.key === 't') {
        e.preventDefault();
        if (buttonRef.current) {
          buttonRef.current.click();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div 
      className={`home-button-container ${isVisible ? 'visible' : ''}`} 
      aria-hidden={!isVisible}
      data-testid="home-button-container"
    >
      <button 
        ref={buttonRef}
        className="home-button" 
        title="Cuộn lên đầu trang (Alt+T)"
        onClick={handleClick}
        aria-label="Cuộn lên đầu trang"
        data-testid="scroll-top-button"
      >
        <FaArrowUp />
        <span className="tooltip">Cuộn lên đầu trang (Alt+T)</span>
      </button>
    </div>
  );
};

export default HomeButton;